// extracted by mini-css-extract-plugin
module.exports = {"indicator":"WorkGroupItemIndicator_indicator__1027u"};